import type { SaleKind } from '../actions/auction/BidFormProvider/BidConfirmationModal/sellerCollectsBidCopy'

export const BANNER_NS = 'Listing.sellerCollects.banner'

/**
 * The banner keys that read differently on an immediate sale.
 *
 * The banner was written for an auction and renders on every Seller Collects
 * listing, offerings included, where there is no winning. A conditional in
 * front of a settled obligation makes it sound optional — to the one audience
 * this banner exists for, a buyer who has never done this before.
 *
 * Anything not listed says the same thing either way and has one string. The
 * headline is deliberately absent: it names who is paid for what and never
 * mentions an outcome.
 */
const PURCHASE_VARIANT_KEYS = new Set([
  'body.feeBearing',
  'body.feeFree',
  'body.unknownFee',
  'toggle',
  'toggleExpanded',
])

/** The message id for a banner key in the tense of this sale. */
export const bannerCopyId = (
  key: string,
  saleKind: SaleKind = 'bid'
): string =>
  saleKind === 'purchase' && PURCHASE_VARIANT_KEYS.has(key)
    ? `${BANNER_NS}.purchase.${key}`
    : `${BANNER_NS}.${key}`

/** Exported for the test that proves every variant exists in the locale. */
export const purchaseVariantBannerKeys = (): string[] => [
  ...PURCHASE_VARIANT_KEYS,
]
